import type { Note } from "@/core/types";

export function getTitle(note: Note): string | undefined {
  if (note.note_type === "Initial Clinical Assessment") {
    return "Diagnostic Interview";
  }

  return note.title;
}
